import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'izy-select-pdf-style-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './select-pdf-style-dialog.component.html',
  styleUrl: './select-pdf-style-dialog.component.scss',
})
export class SelectPdfStyleDialogComponent {
  selectedStyle: string = 'style1'; // Default value

  constructor(
    public dialogRef: MatDialogRef<SelectPdfStyleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    },
  ) {}

  downloadPdf(): void {
    this.dialogRef.close({
      download: true,
      style: this.selectedStyle,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}

@Component({
  selector: 'izy-select-preview-pdf-style-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './select-preview-pdf-style-dialog.component.html',
  styleUrl: './select-pdf-style-dialog.component.scss',
})
export class SelectPreviewPdfStyleDialogComponent {
  selectedStyle: string = 'style1'; // Default value

  constructor(
    public dialogRef: MatDialogRef<SelectPreviewPdfStyleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
    },
  ) {}

  downloadPdf(): void {
    this.dialogRef.close({
      download: true,
      style: this.selectedStyle,
    });
  }

  closeDialog(): void {
    this.dialogRef.close({ download: false });
  }
}
